import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";

export function SidebarLinks({ routes }) {
  let location = useLocation();
  const [accordionOpen, setAccordionOpen] = useState({});

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const toggleAccordion = (name) => {
    setAccordionOpen((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.layout === "/admin") {
        if (route.isAccordion && route.children) {
          return (
            <div key={index} className="mb-2">
              <div
                className={`relative mb-1 flex items-center justify-between px-4 py-2.5 cursor-pointer transition-all duration-200 ease-in-out rounded-lg hover:bg-[#57A863]/10 dark:hover:bg-[#57A863]/20 ${accordionOpen[route.name] ? "bg-[#57A863]/10 dark:bg-[#57A863]/20" : ""
                  }`}
                onClick={() => toggleAccordion(route.name)}
              >
                <span className={`flex items-center ${accordionOpen[route.name]
                    ? "font-bold text-[#57A863] dark:text-[#57A863]"
                    : "font-medium text-gray-600 dark:text-gray-400"
                  }`}>
                  {route.icon || <DashIcon />}
                  <p className="ms-3 text-sm">{route.name}</p>
                </span>
                {accordionOpen[route.name] ? (
                  <MdKeyboardArrowDown className="h-5 w-5 text-[#57A863]" />
                ) : (
                  <MdKeyboardArrowRight className="h-5 w-5 text-gray-600 dark:text-gray-400" />
                )}
              </div>
              {accordionOpen[route.name] && (
                <ul className="pl-4 mt-1">
                  {route.children.map((child, childIndex) => (
                    <Link key={childIndex} to={`${route.layout}/${child.path}`}>
                      <li className={`my-1 flex items-center px-4 py-2.5 cursor-pointer rounded-lg transition-all duration-200 ease-in-out
                        ${activeRoute(child.path)
                          ? "bg-[#57A863] text-white shadow-lg shadow-[#57A863]/30"
                          : "text-gray-600 dark:text-gray-400 hover:bg-[#57A863]/10 dark:hover:bg-[#57A863]/20"
                        }`}>
                        <span className="flex items-center">
                          {child.icon || <DashIcon />}
                          <p className="ms-3 text-sm">{child.name}</p>
                        </span>
                      </li>
                    </Link>
                  ))}
                </ul>
              )}
            </div>
          );
        } else {
          return (
            <Link key={index} to={`${route.layout}/${route.path}`}>
              <div className="mb-2">
                <div className={`relative flex items-center px-4 py-2.5 cursor-pointer rounded-lg transition-all duration-200 ease-in-out
                  ${activeRoute(route.path)
                    ? "bg-[#57A863] text-white shadow-lg shadow-[#57A863]/30"
                    : "text-gray-600 dark:text-gray-400 hover:bg-[#57A863]/10 dark:hover:bg-[#57A863]/20"
                  }`}>
                  <span className="flex items-center">
                    {route.icon || <DashIcon />}
                    <p className="ms-3 text-sm">{route.name}</p>
                  </span>
                </div>
              </div>
            </Link>
          );
        }
      }
      return null;
    });
  };

  return (
    <ul className="px-3">
      {createLinks(routes)}
    </ul>
  );
}

export default SidebarLinks;